define('lib/react/React.PodioView',['require','underscore','react-backbone','lib/view_helpers/base','mixins/ViewHelpersMixin.js'],function (require) {

  var _ = require('underscore');
  var ReactBackbone = require('react-backbone');
  var ViewHelpers = require('lib/view_helpers/base');
  var ReactHelpersMixin = require('mixins/ViewHelpersMixin.js');

  var PodioReactViewMixin = {
    trigger: function() {
      if (_.isUndefined(this.props.eventBus)) {
        throw new Error('Eventbus has not been passed into this component.');
      }

      this.props.eventBus.trigger.apply(this.props.eventBus, arguments);
    }
  };

  return {
    extend: function(spec) {

      spec.mixins = spec.mixins || [];
      spec.mixins = spec.mixins.concat([PodioReactViewMixin, ReactHelpersMixin, { viewHelpers: ViewHelpers }]);

      var factory = ReactBackbone.createBackboneClass(spec);
      factory.isValidReactClass = true;
      return factory;
    }
  };

});

